const PillsCounterBtn = (props) => {
  const clickEvent = ()=>{
      props.callback(true);
  }
  return (
    <button type="button" className={`pills__counter ${props.className ? props.className : ''} ${
        !props.visible ? "hidden" : ""}`} onClick={() => clickEvent()}>
      +{props.text}
    </button>
  );
};
export default PillsCounterBtn;
